<template>
  <footer class="footer px-4 container-fluid">
    <div class="container">
      <div class="footer-content">
        <!-- Logo and Copyright -->
        <div class="brand-section">
          <img src="@/assets/images/logo.png" alt="Semillero del Oeste" class="footer-logo">
          <div class="text-section">
            <p class="copyright mb-0">
              © {{ currentYear }} Semillero del oeste
            </p>
            <div class="credits mt-1">
              <small class="developed-by">
                Desarrollado por <a href="https://permaculture.ar" target="_blank" class="dev-link">
                  <img src="@/assets/images/logo-star-white.svg" alt="spray icon" class="img-fluid col-lg-2 col-5 pe-4" style="margin-top: 13px;">
                </a>
              </small>
            </div>
          </div>
        </div>

        <!-- Social Links -->
        <div class="social-links">
          <a href="https://instagram.com/semillerodeloeste" target="_blank" class="social-link" title="Síguenos en Instagram">
            <i class="fab fa-instagram"></i>
          </a>
          <a href="https://www.facebook.com/profile.php?id=61568482152973" target="_blank" class="social-link" title="Síguenos en Facebook">
            <i class="fab fa-facebook"></i>
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { computed } from 'vue'

const currentYear = computed(() => new Date().getFullYear())
</script>

<style scoped>
.footer {
  padding: 2rem 0;
  position: relative;
  overflow: hidden; /* Añadido para contener la imagen */
  background-color: var(--black-color) !important;
}

.footer-content {
  position: relative; /* Asegurar que esté por encima de la imagen */
  z-index: 1; /* Mayor que el z-index de la imagen */
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  background: linear-gradient(145deg, var(--black-color-2) 0%, var(--black-color-3) 100%);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.brand-section {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.footer-logo {
  height: 35px;
  width: auto;
  opacity: 0.9;
}

.text-section {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.copyright {
  color: var(--white-color-2);
  font-size: 0.9rem;
}

.credits {
  opacity: 0.7;
  transition: opacity 0.3s ease;
}

.credits:hover {
  opacity: 1;
}

.developed-by {
  color: var(--white-color-2);
  font-size: 0.8rem;
}

.dev-link {
  color: var(--primary-color);
  text-decoration: none;
  transition: all 0.3s ease;
  font-weight: 500;
  font-size: 0.8rem;
}

.dev-link:hover {
  color: var(--white-color);
  text-decoration: underline;
}

.social-links {
  display: flex;
  gap: 0.75rem;
}

.social-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  color: var(--white-color-2);
  transition: all 0.3s ease;
  text-decoration: none;
}

.social-link:hover {
  background: var(--primary-color);
  transform: translateY(-3px);
  color: white;
}

.social-link i {
  font-size: 1.1rem;
}

@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    gap: 1.5rem;
    text-align: center;
    padding: 1.25rem;
  }


  .brand-section {
    flex-direction: column;
    gap: 1rem;
  }

  .text-section {
    align-items: center;
  }

  .social-links {
    width: 100%;
    justify-content: center;
  }
}
</style>